var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnTheGoManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47 6v48c0 2.76-2.24 5-5 5h-24c-1.72 0-3.25-.88-4.15-2.2-.53-.8-.85-1.76-.85-2.8v-48c0-2.76 2.24-5 5-5h24c2.38 0 4.38 1.67 4.88 3.9.08.36.12.72.12 1.1z",
    fill: "#35a5f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41 2c-1.105 0-2 .895-2 2v1c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-1c0-1.105-.895-2-2-2v-1h22z",
    fill: "#204272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35 56h-10c-.553 0-1-.447-1-1s.447-1 1-1h10c.553 0 1 .447 1 1s-.447 1-1 1z",
    fill: "#2879d1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m47 6v12.86l-34 23.05v-14.06l33.88-22.95c.08.36.12.72.12 1.1z",
    fill: "#50bcff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m47 25.89v8.44l-33.15 22.47c-.53-.8-.85-1.76-.85-2.8v-5.06z",
    fill: "#50bcff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m42 60h-24c-3.309 0-6-2.691-6-6v-48c0-3.309 2.691-6 6-6h24c3.309 0 6 2.691 6 6v48c0 3.309-2.691 6-6 6zm-24-58c-2.206 0-4 1.794-4 4v48c0 2.206 1.794 4 4 4h24c2.206 0 4-1.794 4-4v-48c0-2.206-1.794-4-4-4z",
    fill: "#204272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTheGoManagement);
export default __webpack_public_path__ + "static/media/on-the-go-management.7bdf6339f273dd219841ee1cc7cfed03.svg";
export { ForwardRef as ReactComponent };